import React from 'react';
import {Trans} from 'react-i18next';
import _get from 'lodash/get';
import DataTable from '../../../../../components/datatable/DataTable';

export default function SameConsent({
  isLoading = true,
  formikProps,
  categories,
}) {
  const columns = [
    {
      Header: (
        <Trans i18nKey="p.s.uiconfiguration.customized.ui.selected">
          Selected
        </Trans>
      ),
      accessor: 'value',
      disableSortBy: true,
      style: {width: '5%', textAlign: 'center'},
      Cell: ({
        cell: {
          row: {original},
        },
      }) => (
        <div className="text-center">
          <input
            type="radio"
            value={original.value}
            onChange={e => {
              _get(formikProps, 'values.user_consents', []);
              formikProps.setFieldValue('user_consents', [
                {
                  template_id: original.value,
                  store_ids: [],
                },
              ]);
            }}
            checked={
              _get(formikProps, 'values.user_consents[0].template_id') ===
              original.value
            }
          />
        </div>
      ),
    },
    {
      Header: (
        <Trans i18nKey="p.s.c.customization.template.name">Template Name</Trans>
      ),
      accessor: 'label',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
    },
  ];

  return (
    <div>
      <DataTable
        columns={columns}
        data={_get(categories, 'tempCategory', [])}
        initState={{
          pageSize: 5,
        }}
        loading={isLoading}
      />
    </div>
  );
}
